angular.module('CaresApp').service('OcrAttachments', function() {});
